import type { Category } from '../../../constants/index.ts';
import { DockerDatasource } from '../../datasource/docker/index.ts';
import { extractPackageFile } from './extract.ts';

export { knownDepTypes } from './dep-types.ts';
export { extractPackageFile };

export const url = 'https://docs.drone.io';
export const categories: Category[] = ['ci'];

export const defaultConfig = {
  managerFilePatterns: ['/(^|/)\\.drone\\.yml$/'],
};

export const supportedDatasources = [DockerDatasource.id];
